// extracted by mini-css-extract-plugin
export default {"page":"n497D","container":"lmtI8","gallery":"aqHVH"};